<template>
  <of-dialog
    :title="formTitle"
    @onCancel="cancel"
    @onConfirm="confirm"
    :isConfirm="isConfirm"
    :width="width"
  >
    <div slot="content">
      <el-form
        ref="form"
        label-width="120px"
        :model="dataForm"
        :rules="editFormRules"
      >
        <el-form-item label="标题：" prop="Title">
          <el-input
            placeholder="请输入标题"
            v-model="dataForm.Title"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="地址：" prop="Address">
          <el-input
            placeholder="请输入地址"
            v-model="dataForm.Address"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="报名条件：" prop="Condition">
          <el-input
            placeholder="请输入报名条件"
            v-model="dataForm.Condition"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="每期人数：" prop="NumEach">
          <el-input
            placeholder="请输入每期人数"
            v-model="dataForm.NumEach"
            clearable
            maxlength="100"
          ></el-input>
        </el-form-item>
        <el-form-item label="封面图：" prop="HeadImge">
          <p>支持png/jpg/jpeg格式，建议尺寸650*360</p>
          <of-upload
            class="upload-demo"
            list-type="picture-card"
            @onPreview="onPreview"
            @onRemove="onRemove"
            @onUpLoad="onUpLoad"
            :limit="1"
            :fileList="pictureList"
            :class="{ hide: hideUploadEdit }"
            accept="image/jpeg, image/gif, image/png, image/jpg"
          >
            <div slot="content">
              <i slot="default" class="el-icon-plus"></i>
            </div>
          </of-upload>
          <el-dialog :visible.sync="dialogVisible" :append-to-body="true">
            <img width="100%" :src="dialogImageUrl" alt />
          </el-dialog>
        </el-form-item>
        <el-form-item label="预约须知：" prop="Notice">
          <el-input
            placeholder="请输入预约须知"
            v-model="dataForm.Notice"
            type="textarea"
            :rows="5"
          ></el-input>
        </el-form-item>
        <el-form-item label="体验馆介绍：" prop="Abstract">
          <of-tinymce
            ref="editor"
            v-model="dataForm.Abstract"
            :height="500"
          ></of-tinymce>
        </el-form-item>
      </el-form>
    </div>
  </of-dialog>
</template>
<script>
import OfDialog from "@/components/controls/of_dialog/of_dialog";
import OfUpload from "@/components/controls/of_upload/of_upload";
import OfTinymce from "@/components/controls/of_editor/of_tinymce";
import { saveAs } from "file-saver";
import api from "@/modules/zjrc/api";

export default {
  name: "edit",
  props: {
    id: {
      type: String,
      default: "",
    },
    formTitle: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      //表单规则
      editFormRules: {
        Title: [{ required: true, message: "标题不能为空", trigger: "blur" }],
        Address: [{ required: true, message: "地址不能为空", trigger: "blur" }],
        Condition: [
          { required: true, message: "报名条件不能为空", trigger: "blur" },
        ],
        NumEach: [
          { required: true, message: "每期人数不能为空", trigger: "blur" },
        ],
        HeadImge: [
          { required: true, message: "封面图不能为空", trigger: "blur" },
        ],
        Abstract: [
          { required: true, message: "体验馆介绍不能为空", trigger: "blur" },
        ],
      },
      isConfirm: false,
      pictureList: [],
      dialogVisible: false,
      dialogImageUrl: "",
      hideUploadEdit: false,
      width: "60%",
      dataForm: {}, //表单对象
    };
  },
  mounted() {
    this.loadData();
  },
  components: {
    OfDialog,
    OfUpload,
    OfTinymce,
  },
  methods: {
    //初始化数据
    loadData() {
      if (this.id) {
        let params = { id: this.id };
        api.QueryTrainById(params).then((res) => {
          if (res.data.Code === 0) {
            this.dataForm = res.data.Data;
            this.getImg();
          }
        });
      }
    },
    //取消
    cancel() {
      this.$emit("formCallBack", null);
    },
    //保存&更新
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.isConfirm = true;
          let params = Object.assign({}, this.dataForm);
          params.DeadLine = 0;
          params.StartTime = 0;
          params.EndTime = 0;
          params.Status = 0;
          params.Type = 3;
          api
            .SaveTrain(params)
            .then((rep) => {
              this.isConfirm = false;
              if (rep.data.Code === 0) {
                this.$message({
                  message: "提交成功",
                  type: "success",
                });
                this.$emit("formCallBack", params);
              } else {
                this.$message({
                  message: rep.data.Message,
                  type: "error",
                });
              }
            })
            .catch((e) => {
              this.isConfirm = false;
              this.$message({
                message: e.toString(),
                type: "error",
              });
            });
        }
      });
    },
    //删除封面图
    onRemove() {
      this.pictureList = [];
      this.dataForm.HeadImge = null;
      this.hideUploadEdit = false;
    },
    //查看图片
    onPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    //上传封面图
    onUpLoad(file) {
      if (file.response.Code === 0) {
        this.dataForm.HeadImge = file.response.Data.FileId;
        this.$message({
          message: "封面图上传成功",
          type: "success",
        });
        this.hideUploadEdit = true;
      }
    },
    //初始化封面图
    getImg() {
      if (
        this.dataForm.HeadImge === undefined ||
        this.dataForm.HeadImge === null ||
        this.dataForm.HeadImge == ""
      ) {
        return;
      }
      this.hideUploadEdit = true;
      this.$http
        .get("/Sys/File/Download?Id=" + this.dataForm.HeadImge)
        .then((res) => {
          let pictureList = [res.config];
          this.pictureList = pictureList.map((item) => {
            return {
              url: item.url,
            };
          });
        });
    },
  },
};
</script>


<style scoped>
.el-textarea > textarea {
  height: 80px;
}

.upload-demo >>> .el-upload input[type="file"] {
  display: none !important;
}

.el-date-editor >>> .el-input__icon {
  display: none;
}
.el-date-editor >>> .el-input__inner {
  width: 90%;
}
</style>

<style>
.hide {
  display: block !important;
}

.hideFile .el-upload--fileList {
  display: none;
}
</style>
